import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewUsersWiseReport = () => { 
    return useQuery({ 
        queryKey: ['viewUsersWiseReport'], 
        queryFn: async () => { 
            const res = await api.get('/reports/active-distributor-users-per-month', {
            }); 
            return res.data?.data; 
        }
     });
};  